<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="isEdit ? 'Cập nhật nhóm phí' : 'Thêm nhóm phí'">
        <template v-slot:preview>
          <b-form @submit.prevent="onSubmit">
            <b-row class="mb-3">
              <b-col cols="4">
                <b-form-group>
                  <template #label>
                    Tên nhóm phí <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="form.name"
                    placeholder="Nhập tên nhóm phí"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group>
                  <template #label>
                    Loại nhóm <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="form.groupType"
                    :options="groupTypeOptions"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group>
                  <template>
                    <label>Doanh nghiệp:</label>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-select
                    v-model="form.companyId"
                    :options="listCompany"
                    value-field="id"
                    text-field="name"
                    required
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled
                        >-- Doanh nghiệp --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="2" v-if="isEdit">
                <b-form-group label="Trạng thái">
                  <b-form-select
                    v-model="form.status"
                    :options="statusOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="6">
                <b-form-group label="Mô tả">
                  <b-form-textarea
                    v-model="form.description"
                    rows="3"
                    placeholder="Nhập mô tả"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button type="submit" variant="primary" :disabled="isSaving">
                  <i class="fas fa-save"></i> {{ isSaving ? 'Đang lưu...' : 'Lưu' }}
                </b-button>
                <b-button variant="secondary" class="ml-2" @click="goBack">
                  <i class="fas fa-arrow-left"></i> Quay lại
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import { COST_GROUP_TYPE, COST_GROUP_TYPE_LABEL } from '../constants';

export default {
  components: { KTCodePreview },
  beforeRouteEnter(_to, from, next) {
    next((vm) => { vm.returnQuery = from && from.name === 'list-cost-groups' ? { ...from.query } : {}; });
  },
  data() {
    return {
      isEdit: false,
      isSaving: false,
      returnQuery: {},
      listCompany: [],
      form: {
        id: null,
        name: '',
        groupType: COST_GROUP_TYPE.EXPENSE,
        description: '',
        companyId: null,
        status: 1,
      },
      groupTypeOptions: [
        { value: COST_GROUP_TYPE.EXPENSE, text: COST_GROUP_TYPE_LABEL[COST_GROUP_TYPE.EXPENSE] },
        { value: COST_GROUP_TYPE.MANAGEMENT, text: COST_GROUP_TYPE_LABEL[COST_GROUP_TYPE.MANAGEMENT] },
      ],
      statusOptions: [
        { value: 1, text: 'Hoạt động' },
        { value: 0, text: 'Ngừng' },
      ],
    };
  },
  created() {
    this.fetchCompany();
    const id = this.$route.query.id;
    if (id) {
      this.isEdit = true;
      this.fetchDetail(id);
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Nhóm phí', route: '/budget/cost-groups' },
      { title: this.isEdit ? 'Cập nhật' : 'Thêm mới' },
    ]);
  },
  methods: {
    makeToastSuccess,
    makeToastFaile,
    fetchCompany() {
      ApiService.get('/company').then((response) => {
        this.listCompany = response.data.data;
      });
    },
    fetchDetail(id) {
      ApiService.get(`v2/cost-groups/${id}`).then(({ data }) => {
        if (data.status === 200) {
          this.form = { ...data.data };
        }
      });
    },
    onSubmit() {
      if (!this.form.companyId) {
        this.makeToastFaile('Vui lòng chọn doanh nghiệp!');
        return;
      }
      this.isSaving = true;
      const payload = { ...this.form };
      const request = this.isEdit
        ? ApiService.put('v2/cost-groups', payload)
        : ApiService.post('v2/cost-groups', payload);

      request
        .then(({ data }) => {
          if (data.status === 200) {
            this.makeToastSuccess(data.message);
            this.$router.push({ name: 'list-cost-groups', query: { ...this.returnQuery } });
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch((err) => handleError(err))
        .finally(() => { this.isSaving = false; });
    },
    goBack() {
      this.$router.push({ name: 'list-cost-groups', query: { ...this.returnQuery } });
    },
  },
};
</script>
